
import moment from 'moment';

import React, { Component}  from 'react';
import styled from 'styled-components';
import CargoWeight from "./CargoWeight";
const StyledOrderDetailExtraInfo = styled.div`
  
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 15px;
  
  .label {
    font-size: 12px;
    color: #828282;
    margin-bottom: 5px;
  }
  
  margin-top: 30px;
`;

const DATETIME_FORMAT = 'DD.MM.YYYY HH:mm';
const DATE_FORMAT = 'DD.MM.YYYY'

export default class OrderDetailExtraInfo extends Component {

  render() {
    const { order } = this.props;
    let items = [];
    if (order.hbl_date) {
      items.push(['Дата HBL', moment(order.hbl_date).format(DATE_FORMAT)]);
    }
    if (order.station_arrival_date) {
      items.push(['Дата прихода на станцию', moment(order.station_arrival_date).format(DATETIME_FORMAT)]);
    }
    if (order.empty_arrival_date) {
      items.push(['Дата сдачи порожнего', moment(order.empty_arrival_date).format(DATE_FORMAT)]);
    }
    if (order.cargo_weight) {
      items.push(['Вес груза', <CargoWeight item={order}/>]);
    }
    if (order.cargo) {
      items.push(['Груз', order.cargo]);
    }
    if (order.shipper) {
      items.push(['Грузоотправитель', order.shipper.name]);
    }
    if (order.consignee) {
      items.push(['Грузополучатель', order.consignee.name]);
    }

    return (
      <React.Fragment>
        {items.length > 0 && (
          <StyledOrderDetailExtraInfo>
            {items.map((item, index) =>
              <div key={index}>
                <div className={'label'}>{item[0]}</div>
                <div style={{whiteSpace: 'pre-line'}}>{item[1]}</div>
              </div>
            )}
          </StyledOrderDetailExtraInfo>
        )}
      </React.Fragment>
    )
  }
}
